module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: _vm.currentWidth
  }, [(_vm.idLabel) ? _c('label', [_vm._v("\n    " + _vm._s(_vm.idLabel) + "\n    "), (_vm.isMandatory) ? _c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.inputType === 'number') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.inputValue),
      expression: "inputValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholderValue,
      "min": _vm.minValue,
      "max": _vm.maxValue
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : (_vm.inputType !== 'date') ? _c('div', [((_vm.inputType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "placeholder": _vm.placeholderValue,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.inputValue) ? _vm._i(_vm.inputValue, null) > -1 : (_vm.inputValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.inputValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.inputValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inputValue = $$c
        }
      }
    }
  }) : ((_vm.inputType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "placeholder": _vm.placeholderValue,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.inputValue, null)
    },
    on: {
      "change": function($event) {
        _vm.inputValue = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "placeholder": _vm.placeholderValue,
      "type": _vm.inputType
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "formDatePicker"
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.$t('common.datepicker_format_date'),
      "placeholder": _vm.placeholderValue
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a7da3ed", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a7da3ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/formWriteGroupLabelInput.vue
// module id = 1678
// module chunks = 2